import MobileDetect from 'mobile-detect';
import constants from './UserConstants';
import globalConstants from '../../lib/globalConstants';

const md = new MobileDetect(window.navigator.userAgent);

const initialState = {
    isMobile: !!md.mobile(),
    showLoginModal: false,
    showRegisterModal: false,
    information: {
        username: localStorage.getItem('username') || null,
        name: localStorage.getItem('name') || null,
        email: localStorage.getItem('email') || null,
    },
    preferences: {
        lang: localStorage.getItem('locale') || 'en',
        currency: globalConstants.CURRENCIES.DOLLAR,
    },
    authentication: {
        valid: (localStorage.getItem('token')) ? !(localStorage.getItem('token') < Date.now() / 1000) : null,
        token: localStorage.getItem('token') || null,
        loginAt: localStorage.getItem('loginAt') || null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
    case constants.SET_USER_INFORMATION: {
        return Object.assign({}, state, { information: { username: action.payload.username, email: action.payload.email, name: action.payload.name } });
    }
    case constants.SET_TOKEN_INFORMATION: {
        return Object.assign({}, state, { authentication: { token: action.payload.token, refreshToken: action.payload.refreshToken, tokenExpiration: action.payload.tokenExpiration, valid: action.payload.valid, loginAt: new Date() } });
    }
    case constants.CLEAR_USER_INFORMATION: {
        return Object.assign({}, state, { information: { username: null, email: null, name: null } });
    }
    case constants.CLEAR_TOKEN_INFORMATION: {
        return Object.assign({}, state, { authentication: { token: null, refreshToken: null, tokenExpiration: null, valid: null, loginAt: null } });
    }
    case constants.SHOW_LOGIN_MODAL: {
        return Object.assign({}, state, { showLoginModal: true });
    }
    case constants.HIDE_LOGIN_MODAL: {
        return Object.assign({}, state, { showLoginModal: false });
    }
    case constants.SHOW_REGISTER_MODAL: {
        return Object.assign({}, state, { showRegisterModal: true });
    }
    case constants.HIDE_REGISTER_MODAL: {
        return Object.assign({}, state, { showRegisterModal: false });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/UserReducer/UserReducer.js